import Fanfare from './Fanfare'

export default Fanfare